import { CSSProperties, ReactNode } from "react";
import "./track.css";

type MarqueeProps = {
  children: ReactNode;
  /** Seconds for one full loop. */
  duration?: number;
  reverse?: boolean;
  /** Gap between items, in px. */
  gap?: number;
  className?: string;
};

/**
 * Endlessly scrolling row. Content is rendered twice so the loop is seamless;
 * the copy is hidden from screen readers. Stops for reduced-motion users.
 */
const Marquee = ({ children, duration = 40, reverse = false, gap = 48, className }: MarqueeProps) => {
  const style = {
    "--is-marquee-dur": `${duration}s`,
    "--is-marquee-gap": `${gap}px`,
  } as CSSProperties;

  return (
    <div className={"is-marquee" + (className ? ` ${className}` : "")} style={style}>
      <div className={"is-marquee__track" + (reverse ? " is-marquee__track--reverse" : "")}>
        <div className="is-marquee__group">{children}</div>
        <div className="is-marquee__group" aria-hidden="true">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
